// extracted by mini-css-extract-plugin
export default {"gridStyling":"views-ContentPage-components-themes-PP-latestProducts__gridStyling--vga3h"};